import React, { useEffect } from "react";

export default function CorrectAddressList({
  showModal,
  correctAddressesList,
  handleCorrectAddressSelect,
}) {
  /*   All States
   ********************************************* */

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */
  //   useEffect(() => {
  //     let timeout = setTimeout(() => {
  //       console.log(correctAddressesList);
  //     }, 50);
  //     return () => clearTimeout(timeout);
  //   }, [correctAddressesList]);
  return (
    <div>
      {showModal && (
        <div className="">
          <div className="">
            <div className=" table-responsive">
              <table className="table table-hover">
                <thead className="">
                  <tr>
                    <th scope="col">Address Type</th>
                    <th scope="col">Address 1</th>
                    <th scope="col">Region</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Table rows will be rendered by the map function below */}
                  {correctAddressesList.map((address, index) => (
                    <tr key={index}>
                      <td>{address?.AddressClassification?.Description}</td>
                      <td>{address?.AddressKeyFormat?.AddressLine[0]}</td>
                      <td>{address?.AddressKeyFormat?.Region}</td>
                      {/* <td>{address?.AddressKeyFormat?.PoliticalDivision1}</td>
                      <td>{address?.AddressKeyFormat?.PostcodePrimaryLow}</td> */}
                      <td>
                        {/* Add any action buttons here */}
                        <button
                          onClick={(e) => {
                            handleCorrectAddressSelect(address, e);
                            showModal(false);
                          }}
                          className="btn btn-success btn-sm"
                        >
                          Select
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
